import { useState } from "react";
import { Donate } from "./components/Donate";
import { daimo } from "./config";

export function App() {
  const [completed, setCompleted] = useState(false);
  return (
    <main>
      <img src="/groundwire.png" alt="Groundwire Foundation" width={64} height={64} />
      <h1>Groundwire Foundation</h1>
      <p>
        {completed
          ? "Thank you! An email will be sent with receipt of your donation."
          : "Now accepting donations in stablecoins and crypto."}{" "}
        <a href={daimo.returnUrl}>Return to Groundwire Foundation</a>
      </p>
      {!completed && <Donate onSuccess={() => setCompleted(true)} />}
    </main>
  );
}
